import { Grid, Zoom } from "@material-ui/core";
import "./mining.scss";
import Centerpng from "../../assets/icons/centerpng.png";

function Mining() {
    return (
        <div className="dashboard-view">
            <div className="dashboard-infos-wrap mining-page">
                <Zoom in={true}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <img src={Centerpng} className={"centerpng"} />
                        <div style={{ textAlign: "center", color: "white", fontSize: 28 }}>
                            <p>coming soon</p>
                        </div>
                    </Grid>
                    {/* <Grid container spacing={4}>
                        <Grid item lg={6} md={6} sm={6} xs={12}>
                            <Grid container spacing={2}>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <img src={Centerpng} className={"centerpng"} />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid> */}
                </Zoom>
            </div>
        </div>
    );
}

export default Mining;
